import React from 'react';
import { motion } from 'framer-motion';

export default function LocationMap() {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl"
    >
      <h2 className="text-4xl font-bold text-gray-900 mb-4 retro-text">
        HER BOR VI
      </h2>
      <p className="text-lg text-gray-600 mb-6">
        Zoom ind og se kortet – vi er her, klar til at forkæle dig! 🗺️
      </p>

      {/* Map Container */}
      <div className="relative rounded-xl overflow-hidden shadow-xl h-[400px] mb-6">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2247.6891625670584!2d12.538767716266662!3d55.74459498055411!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46524defdd165da1%3A0x6adccdc5a5bb91e8!2sBennys%20P%C3%B8lsevogn!5e0!3m2!1sen!2sdk!4v1707654321000!5m2!1sen!2sdk"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="absolute inset-0"
          title="Benny's Pølsevogn Location"
        />
      </div>

      {/* Single Image */}
      <motion.div
        whileHover={{ scale: 1.05 }}
        className="relative aspect-[4/3] rounded-xl overflow-hidden shadow-lg"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-red-500/10 to-amber-500/10" />
        <img
          src="https://i.postimg.cc/cC6HSG58/Logo-png.png"
          alt="Benny's Pølsevogn Location"
          className="w-full h-full object-contain bg-white"
        />
      </motion.div>
    </motion.div>
  );
}